"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isFromEu_1 = __importDefault(require("./isFromEu"));
/**
 * @param company Company who creates the invoice or quote
 * @param client The client to whom the invoice/quote is addressed
 * @returns Apply or not VAT reverse charge (autoliquidation de TVA)
 */
const canDoVatReverseCharge = (company, client) => {
    const clientCountryCode = client.vatId.slice(0, 2);
    const companyCountryCode = company.legalVATNumber.slice(0, 2);
    return (client.type === 'ORGANIZATION' && // VAT reverse charge is only available for organizations
        client.vatId !== '' && // check if the client is VAT taxable
        company.legalVATNumber !== '' && // check if the company is VAT taxable
        (0, isFromEu_1.default)(clientCountryCode) && // VAT reverse charge available only between EU countries
        (0, isFromEu_1.default)(companyCountryCode) &&
        // if the client and the company are in the same UE country,
        // then the vat reverse charge is not available
        clientCountryCode !== companyCountryCode);
};
exports.default = canDoVatReverseCharge;
